export default [
  {
    text: 'Nenhum',
    value: null,
  },
  {
    value: 'CIB',
    text: 'Cashin boleto',
  },
  {
    value: 'CICOBR',
    text: 'Cashin cobrar',
  },
  {
    value: 'CIP',
    text: 'Cashin pix',
  },
  {
    value: 'CITTD',
    text: 'Cashin transferência TED DOC',
  },
  {
    value: 'COPC',
    text: 'Cashout pagamento conta',
  },
  {
    value: 'COT',
    text: 'Cashout transferência',
  },
  {
    value: 'COTI',
    text: 'Cashout transferência interna',
  },
  {
    value: 'COPCCON',
    text: 'Cashout pagamento conta concessionária',
  },
  {
    value: 'COPCTRIB',
    text: 'Cashout pagamento conta tributos',
  },
  {
    value: 'DEPCLI',
    text: 'Depósito cliente',
  },
];
